// {{WORKTREE_ROOT}}/picosponsorconsole/app/utils/locale/boundary.generated.ts
// GENERATED by scripts/gen-boundary-strings.mjs from locales.json (en-US) — never hand-edit (K-09). Used only by the
// root ErrorBoundary in the one case where the root loader produced no data (a crash before it returned).
export const BOUNDARY_STRINGS = {
  "title": "We couldn't load this.",
  "body": "The page didn't load. Nothing is lost — try again.",
  "reload": "Reload the page",
  "notFoundTitle": "We couldn't find that page."
} as const;
